/**
 * NOT-590 — a stable per-line token for the optional-selection checkboxes on
 * the public quote.
 *
 * Keying that state on `lineItemId` broke the moment two lines could share a
 * catalog item, which service components make routine: two services that each
 * include the same optional part render two rows. Sharing one key meant ticking
 * either flipped both — in the displayed total AND in the approval payload the
 * customer submits.
 */

export interface OptionalKeyable {
  lineKey?: string | null;
  lineItemId: string;
}

/**
 * `lineKey` is the per-line identity. The positional fallback covers legacy
 * rows saved before it existed, and is stable for a given rendered document.
 */
export function optionalKey(line: OptionalKeyable, index: number): string {
  return line.lineKey ?? `${line.lineItemId}#${index}`;
}
